module.exports = __webpack_public_path__ + "img/pp6.24f610c1.png";